import type { ReplayData } from './customerServiceConversation'
import api from '../index'

export interface CustomerServiceTicket {
  id: number
  ticket_no: string
  title: string
  description: string | null
  type: string
  source_type: string
  source_id: number
  user_id: number
  priority: string
  status: string
  assignee_admin_id: number | null
  due_at: string | null
  created_at: string | null
  relations?: Array<{ type: string, id: number }>
  parties?: Array<Record<string, any>>
  evidence?: Array<{
    id: number
    evidence_type: string
    attachment_id: number | null
    summary: string | null
    review_status: string
  }>
  logs?: Array<{
    id: number
    log_type: string
    content: string | null
    created_at: string
  }>
}

export function ticketPage(params: Record<string, unknown>) {
  return api.get<
    unknown,
    { data: { list: CustomerServiceTicket[], total: number } }
  >('/admin/service/ticket/ticket/list', { params })
}
export function ticketDetail(id: number) {
  return api.get<unknown, { data: CustomerServiceTicket }>(
    `/admin/service/ticket/ticket/${id}`,
  )
}
export function ticketReplay(id: number) {
  return api.get<unknown, { data: ReplayData }>(`/admin/service/ticket/ticket/${id}/replay`)
}
export function ticketStatus(id: number, status: string) {
  return api.post(`/admin/service/ticket/ticket/${id}/status`, { status })
}
export function ticketNote(id: number, content: string) {
  return api.post(`/admin/service/ticket/ticket/${id}/note`, { content })
}
export function ticketReply(id: number, content: string) {
  return api.post(`/admin/service/ticket/ticket/${id}/reply`, { content })
}
export function ticketParty(id: number, data: Record<string, unknown>) {
  return api.post(`/admin/service/ticket/ticket/${id}/party`, data)
}
export function ticketEvidence(id: number, data: Record<string, unknown>) {
  return api.post(`/admin/service/ticket/ticket/${id}/evidence`, data)
}
export function ticketCreateFromBusiness(data: {
  source_type: 'feedback' | 'after_sale' | 'complaint' | 'order'
  source_id: number
  user_id: number
  title: string
  description?: string
  type: 'consultation' | 'complaint' | 'after_sale' | 'dispute'
  priority: 'low' | 'normal' | 'high' | 'urgent'
  relations?: Array<{ type: string, id: number }>
}) {
  return api.post<unknown, { data: CustomerServiceTicket }>('/admin/service/ticket/ticket/from-business', data)
}
